import cryptoRandomString from "crypto-random-string";
import { Md5 } from "ts-md5";
import { TBaseType } from "./CommonTypes";

export class CommonService {

  private static tag: string = "CommonService";

  //#region filters
  /**
   * @abstract filter function for not null abd not undefined items
   */
  public static notNuDe<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
  }
  //#endregion
 
  //#region string
  public static removeAllWhiteSpacesFromString(str: string): string {
    return str.replace(/\s/g,'')
  }
  //#endreigon


  //#region date
  public static getCurrentTimeStampInSeconds(): number { return Math.floor((new Date()).getTime()/1000); }

  /**
   * @abstract format is f.e.: "2018-01-01"
   */
  public static getStringFromDateYYYYDDMM(d: Date | undefined | null, counter: number = 0): string | undefined {
    if(d == undefined || d == null) return undefined
    try {
      try {
        if(counter >= 100) return "";
        // let min = '' + (d!!.getMinutes() + 1);
        // let hour = '' + (d!!.getHours() + 1);
        let month = '' + (d!!.getMonth() + 1);
        let day = '' + d!!.getDate();
        let year = d!!.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        //if (min.length < 2) min = '0' + min;
        //if (hour.length < 2) hour = '0' + day;

        return [year, month, day].join('-');
      } catch(e) {
        return this.getStringFromDateYYYYDDMM(new Date(), counter + 1)
      } 
        }catch(e) {
        return undefined
    }
  }

  public static getDateFromString(strDate: string | undefined): Date | null {
    try {
      //if(parseInt(strDate!!.split("-")[0])<1900) throw Error("<1900")
      const result = new Date(strDate!!)
      //if (result.getFullYear() < 1900) throw Error("");
      return result
    } catch (e) {
      return null
    }
  }

  public static getDateFromTimeStampInSeconds(timeStampInSeconds: number | undefined | null): Date | undefined {
    if(timeStampInSeconds == undefined || timeStampInSeconds == null) return undefined
    try {
      
      return (new Date(timeStampInSeconds!! * 1000));
    }catch(e) {
      return undefined
    }
  }

  public static mapDateToTimeStampInSeconds(date: Date | undefined): number {
    try {
      return (date!!.getTime()/1000)
    }catch(e) {
      return 0
    }
  }

  public static getDateStringFromTimeStampInSeconds(timeStampInSeconds: number | undefined): string | null {
    try {
      if (timeStampInSeconds == undefined) return null;
      let date: Date = this.getDateFromTimeStampInSeconds(timeStampInSeconds)!!;
  
      return date.toLocaleString();
    } catch(e) {
      return null;
    }
  }
  //#endregion



  //#region valueMappings
  public static mapBooleanToString(item: boolean | undefined): string {
    if (item == undefined) return "false";
    if (item) return "true";
    return "false;"
  }
  public static mapStringToBoolean(item: string | undefined): boolean {
    if (item == undefined || item == "false" || item == "0") return false;
    return true;
  }
  public static mapStringToNumber(item: string | null | undefined): number | null {
    if(item == null || item == undefined) return null;
    try {
      return Number(item);
    }catch(e) {
      return null;
    }
  }
  public static mapNumberToString(item: number): string | null {
    try {
      return item?.toString();
    }catch(e) {
      return null;
    }
  }
  //#endregion


  //#region arrays
  public static concatBaseTypeArrays<TBaseType>(a1: TBaseType[], aToAdd: TBaseType[] ): TBaseType[] {
    return a1.concat(aToAdd);
  }

  public static baseTypeArrayIncludesItem<TBaseType>(a: TBaseType[], item: TBaseType) {
    for(let idx: number = 0; a.length-1; idx++) {
      if(a[idx] === item) return true;
    }
    return false;
  }

  public static mapStringToArrayOfStrings(str: string, delimiter: string  = ";"): string[] {
    const strs = str.split(delimiter)
    return strs;
  }
  public static mapArrayOfStringsToString(ar: string[], delimiter: string  = ";"): string {
    let result = "";
    ar.map((it, idx) => { result += (idx < ar.length - 1) ? it + delimiter : it })
    return result;
  }
  //#endregion


  //#region arraySorting
    /**
     * @param items - items to sort
     * @arr - integers to sort that have the same index as the items to sort
     */
    public static bubbleSortByToSortIntList<T>(items: T[], toSort: number[], ascending: boolean): T[]{

      switch (ascending) {
        case true: return this.bubbleSortAscInternalByInt<T>(items,toSort);
        case false: return this.bubbleSortDescInternalByInt<T>(items,toSort);
      }
    }

    private static bubbleSortAscInternalByInt<T>(items: T[], arrToSort: number[]): Array<T> {
      try {
        let n = arrToSort.length
        for (let i: number = 0; i<= n - 1; i++) {
          for (let j: number = 0; j<= n - i - 1; j++) {
            if (arrToSort[j] >= arrToSort[j + 1]) {
              // swap arrToSort
              let temp = arrToSort[j]
              arrToSort[j] = arrToSort[j + 1]
              arrToSort[j + 1] = temp
              // swap elements
              let tempItem = items[j]
              items[j] = items[j + 1]
              items[j + 1] = tempItem
            }
          }
        }

        return items;
      } catch (e) {
        //console.log(this.tag + "bubbleSortAscInternal() " +e )
        return items
      }
    }

    private static bubbleSortDescInternalByInt<T>(items: T[], arrToSort: number[]): T[] {
      try {
        let n: number = arrToSort.length
        for (let i: number = 0; i <= n - 1; i++) {
          for (let j: number = 0; j <=  n - i - 1; j++) {
            if (arrToSort[j] <= arrToSort[j + 1]) {
              // swap arrToSort
              let temp = arrToSort[j]
              arrToSort[j] = arrToSort[j + 1]
              arrToSort[j + 1] = temp
              // swap elements
              let tempItem = items[j]
              items[j] = items[j + 1]
              items[j + 1] = tempItem
            }
          }
        }
        return items;
      } catch (e) {
        //console.log(this.tag + " bubbleSortDescInternal() "+ e)
        return items
      }
    }

    //#endregion


  //#region security
  public static getObjectHash(obj: any) : string {
    return Md5.hashStr(JSON.stringify(obj));
  }

  public static getRandomHash(length: number = 32) : string {
    return cryptoRandomString({length: length});
  }
  //#endregion
}